import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const variantAnalyticsSchema_ = z.object({
  variantId: z.string(),
  productId: z.string(),
  productTitle: z.string(),
  variantTitle: z.string(),
  price: z.number(),
  impressions: z.number(),
  addToCarts: z.number(),
  checkouts: z.number(),
  impressionToAddToCartRate: z.number(),
  addToCartToCheckoutRate: z.number(),
  overallConversionRate: z.number(),
});
export const variantAnalyticsSchema: z.ZodType<VariantAnalyticsSchema> =
  variantAnalyticsSchema_;
export interface VariantAnalyticsSchema
  extends z.infer<typeof variantAnalyticsSchema_> {}

const pricingTestTreatmentAnalyticsSchema_ = z.object({
  treatmentId: z.string(),
  treatmentName: z.string(),
  variantAnalytics: z.array(variantAnalyticsSchema),
  totalImpressions: z.number(),
  totalAddToCarts: z.number(),
  totalCheckouts: z.number(),
  overallConversionRate: z.number(),
});
export const pricingTestTreatmentAnalyticsSchema: z.ZodType<PricingTestTreatmentAnalyticsSchema> =
  pricingTestTreatmentAnalyticsSchema_;
export interface PricingTestTreatmentAnalyticsSchema
  extends z.infer<typeof pricingTestTreatmentAnalyticsSchema_> {}

const pricingTestAnalyticsSchema_ = z.object({
  pricingTestId: z.string(),
  treatmentAnalytics: z.array(pricingTestTreatmentAnalyticsSchema),
  statisticalSignificance: z.number().nullable(),
});
export const pricingTestAnalyticsSchema: z.ZodType<PricingTestAnalyticsSchema> =
  pricingTestAnalyticsSchema_;
export interface PricingTestAnalyticsSchema
  extends z.infer<typeof pricingTestAnalyticsSchema_> {}

export const getPricingTestAnalytics = {
  name: "getPricingTestAnalytics" as const,
  input: z.object({ pricingTestId: zExt.objectId() }),
  output: pricingTestAnalyticsSchema,
};
